import React, {useState} from "react";
import { useDisclosure } from "@chakra-ui/react";
import { ModalComponent } from "../../newComponents/modalComponent";
import GeneralSection from "../../newComponents/generalSection";

function TextPanel({ block }) {

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [show, setShow] = useState(false)

  let element;
  switch(block.textPanelConfig) {
    case "popup":
      element = 
        <>
          <div className="prose max-w-none mb-4 body-content-rich-text-bullets" dangerouslySetInnerHTML={{ __html: block.summary, }}/>
          <button className="section__link link-more text-gray-3 mb-8" onClick={onOpen}>Read more</button>
          <ModalComponent isOpen={isOpen} onClose={onClose}>
            <div className="prose max-w-none mb-4 body-content-rich-text-bullets" dangerouslySetInnerHTML={{__html: block.body, }}/>
          </ModalComponent>
        </>;
      break;
    case "expand":
      element = 
        <>
          <header className="section__head">
            <p className="section__title title h2 text-gray">{block.heading}</p>
            <p className="section__subtitle subtitle text-orange">{block.subHeading}</p>
            <div className={`section__head-description ${show ? "hidden" : null}`} dangerouslySetInnerHTML={{__html: block.summary,}}/>
          </header>
          <div className={`mb-4 ${show ? null : "hidden"}`}>
            <div dangerouslySetInnerHTML={{__html: block.body}}/>
          </div>
          <div className="flex justify-center">
            <button className="underline" onClick={() => setShow(!show)}>{show ? "Read less" : "Read more"}</button> 
          </div>
        </>;
      break;
    case "none":
      element = 
        <header className="section__head">
          <p className="section__title title h2 text-gray">{block.heading}</p>
          <p className="section__subtitle subtitle text-orange">{block.subHeading}</p>
          <div className="section__head-description" dangerouslySetInnerHTML={{__html: block.summary,}}/>
        </header>;
      break;
    default:
      element = <div>Text panel type not found.</div>;
      break;
  }
  
  return (<GeneralSection>{element}</GeneralSection>);
}

export default TextPanel;
